

const BuildURL = {
  Type: process.env.REACT_APP_ENV, //Production OR Staging OR Local OR Development OR Integration OR IntegrationDev
  Environment: {
    Production: {
      IPADDRESS: "lob.tmilltd.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "https://lobsapintrfc.tmilltd.com/",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "6b7a6fea-7034-4edd-8dcd-19139f60d852",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: "https://lob.tmilltd.com/railways"
      },
      RAILWAYS_POWER_BI_URL:process.env.RAILWAYS_POWER_BI_URL,
      RAILWAYS_DEBTORS_URL:process.env.RAILWAYS_DEBTORS_URL
    },
    AZURE_QA: {
      IPADDRESS: "qarailways.azurewebsites.net",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: true,
      PORT: '',
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'https://qarailways.azurewebsites.net/railways'
      },
      RAILWAYS_POWER_BI_URL:"https://app.powerbi.com/view?r=eyJrIjoiYTNmZjdkYWUtMThhNC00NGJhLTljNzQtOGYyYTczODdhNjUxIiwidCI6IjllYTRlM2E2LTI5MDgtNGQwMS1hY2U3LWVjMzViMTI5MGI4MiIsImMiOjZ9",
      RAILWAYS_DEBTORS_URL:"https://app.powerbi.com/view?r=eyJrIjoiYzIxMGQxZTYtMTM0NS00NGZiLWFiYmItYjE2ZTE2ZDA5ZTk4IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
    },
    QA: {
      IPADDRESS: "demo.msr-it.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 40115,
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40115",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60"
      },
      RAILWAYS_POWER_BI_URL:"https://app.powerbi.com/view?r=eyJrIjoiYTNmZjdkYWUtMThhNC00NGJhLTljNzQtOGYyYTczODdhNjUxIiwidCI6IjllYTRlM2E2LTI5MDgtNGQwMS1hY2U3LWVjMzViMTI5MGI4MiIsImMiOjZ9",
      RAILWAYS_DEBTORS_URL:"https://app.powerbi.com/view?r=eyJrIjoiYzIxMGQxZTYtMTM0NS00NGZiLWFiYmItYjE2ZTE2ZDA5ZTk4IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
   },
    Development: {
      IPADDRESS: "demo.msr-it.com",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 40114,
      EMAIL_SERVICE_END_POINT: "http://demo.msr-it.com:40114",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'http://localhost:3000/railways'
      },
      RAILWAYS_POWER_BI_URL:"https://app.powerbi.com/view?r=eyJrIjoiYTNmZjdkYWUtMThhNC00NGJhLTljNzQtOGYyYTczODdhNjUxIiwidCI6IjllYTRlM2E2LTI5MDgtNGQwMS1hY2U3LWVjMzViMTI5MGI4MiIsImMiOjZ9",
      RAILWAYS_DEBTORS_URL:"https://app.powerbi.com/view?r=eyJrIjoiYzIxMGQxZTYtMTM0NS00NGZiLWFiYmItYjE2ZTE2ZDA5ZTk4IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
   },
    Local: {
      IPADDRESS: "localhost",
      APPDEFAULTURL: "railwaysapi",
      ISSECURE: false,
      PORT: 8084,
      EMAIL_SERVICE_END_POINT: "http://localhost:8095",
      SAP_CONNECTION_DETAILS: {
        END_POINT: "http://52.172.220.250:8087",
      },
      AD_AUTHENTICATION: {
        CLIENT_ID: "8a19f4cb-132f-44ef-8ed6-78e1586afffe",
        TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
        redirectURI: 'http://localhost:3000/railways'
      },
      RAILWAYS_POWER_BI_URL:"https://app.powerbi.com/view?r=eyJrIjoiYTNmZjdkYWUtMThhNC00NGJhLTljNzQtOGYyYTczODdhNjUxIiwidCI6IjllYTRlM2E2LTI5MDgtNGQwMS1hY2U3LWVjMzViMTI5MGI4MiIsImMiOjZ9",
      RAILWAYS_DEBTORS_URL:"https://app.powerbi.com/view?r=eyJrIjoiYzIxMGQxZTYtMTM0NS00NGZiLWFiYmItYjE2ZTE2ZDA5ZTk4IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
   },
  },
  getServiceURL: function () {
    var SERVICEADDRESS;
    var port = BuildURL.Environment[BuildURL.Type].PORT;
    var IPADDRESS = BuildURL.Environment[BuildURL.Type].IPADDRESS;
    var isSecure = BuildURL.Environment[BuildURL.Type].ISSECURE;
    var httpText;
    if (isSecure) httpText = "https://";
    else httpText = "http://";
    if (port !== "") {
      //HOSTADDRESS =  'http://' + IPADDRESS + ':' + PORT + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        ":" +
        port +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    } else {
      //HOSTADDRESS = 'http://' + IPADDRESS + '/' + APPDEFAULTURL;
      SERVICEADDRESS =
        httpText +
        IPADDRESS +
        "/" +
        BuildURL.Environment[BuildURL.Type].APPDEFAULTURL;
    }
    return SERVICEADDRESS;
  },
  getEmailServiceEndpoint: function () {
    return BuildURL.Environment[BuildURL.Type].EMAIL_SERVICE_END_POINT;
  },
  getSapServiceEndpointConfig: function () {
    return BuildURL.Environment[BuildURL.Type].SAP_CONNECTION_DETAILS;
  },
  geAdAuthConfig: function () {
    return BuildURL.Environment[BuildURL.Type].AD_AUTHENTICATION;
  },
};
export default { BuildURL };
